/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentJobUpdateDetailsSpec } from './agentJobUpdateDetailsSpec';
import { AgentJobStatusEnum } from './agentJobStatusEnum';


export interface AgentJobUpdateSpec { 
    /**
     * More details
     */
    details?: Array<AgentJobUpdateDetailsSpec>;
    /**
     * Agent Job ID
     */
    id: string;
    status: AgentJobStatusEnum;
    /**
     * Update Timestamp.
     */
    update_ts: Date;
}
export namespace AgentJobUpdateSpec {
}


